<div class="advanced-filter-container">

<mat-checkbox (click)="$event.stopPropagation()"
              [(ngModel)]="chkIncludeCustom" (change)="chkCustomClickHandler($event)"
              style="margin-bottom:10px;">
    Include Agency Custom Qualification Questions
</mat-checkbox>

<div #questionsTable class="table-container mat-elevation-z1" id="questionsTable"
          tabindex="-1" style="height: 420px; width: 100%; overflow-y: auto; outline: none;">
        <table mat-table [dataSource]="dataSource" style="width:100%;">

	<!-- Check box -->
    <ng-container matColumnDef="chk">
        <th mat-header-cell *matHeaderCellDef class="table-header-style-local" style="min-width: 50px; width: 50px;">
        </th>
        <td mat-cell class="table-row-override table-detail-style-local" style="width: 50px;" *matCellDef="let
        element;">
           <mat-checkbox [(ngModel)]="element.chk" > 
		</mat-checkbox>
        </td>
    </ng-container>

    <!-- Category Column -->
    <ng-container matColumnDef="category">
        <th mat-header-cell *matHeaderCellDef class="table-header-style-local" style="min-width: 70px; width: 70px; padding-left: 3px;">
            Category
        </th>
        <td mat-cell class="table-row-override" style="width: 70px; padding-left: 3px;" *matCellDef="let element">
            {{element.category}}
        </td>
    </ng-container>

    <!-- Qualification Questions Column -->
    <ng-container matColumnDef="question">
        <th mat-header-cell *matHeaderCellDef class="table-header-style-local" style="min-width: 430px; width: 430px;
        padding-left: 3px;">
            Qualification Questions
        </th>
        <td mat-cell
            class="table-row-override"
            style="width: 430px; padding-left: 3px;" *matCellDef="let element">
            {{element.question}}
        </td>
    </ng-container>

    <!-- Response Column -->
    <ng-container matColumnDef="response">
        <th mat-header-cell *matHeaderCellDef class="table-header-style-local" style="min-width: 140px; width: 140px;
         padding-left: 3px;">
            Response
        </th>
        <td mat-cell class="table-row-override" style="width: 140px;
        padding-left: 3px;" *matCellDef="let element">
         <span *ngIf="element.category==='Master'">
         	 <dw-dropdown
		                id="responseYnd1"
		                [selectedItem]="element.response"
		                (itemSelected)="element.response = $event"
		                [controlWidth]="'125px'"
                        [fontSize]="'9pt'"
                        [disabled]="!element.chk"
		                [useStatusOptions]="'ynd'"
                        [ngClass]="'dropdown-override'">
		     </dw-dropdown>
         </span>
         <span *ngIf="element.category==='Custom'"  [matTooltip]="getCustomFieldDescription(element.controlType)" style="margin-right: 10px;">
         	<span *ngIf="element.controlType=='Text'">
         		<input [(ngModel)]="element.response" [disabled]="!element.chk" style="width: 125px;"/>
         	</span>
	         	 <span *ngIf="element.controlType === 'Number'">
	            		<input type="number" style="width: 125px;" [(ngModel)]="element.response" [disabled]="!element.chk"/>
	        	</span>
         	 <span *ngIf="element.controlType === 'YND'" >
		            <dw-dropdown
		                id="responseYnd2"
		                [selectedItem]="element.response"
		                (itemSelected)="element.response = $event"
		                [controlWidth]="'125px'"
                        [fontSize]="'9pt'"
                        [disabled]="!element.chk"
		                [useStatusOptions]="'ynd'"
                        [ngClass]="'dropdown-override'">
		            </dw-dropdown>
        	</span>
        	<span *ngIf="element.controlType==='Date'">
		          <dw-calendar appendTo="body"
		           [(ngModel)]="element.response" ngDefaultControl
		           [disabled]="!element.chk"
		            [ngStyle]="{ 'width.px': 125, 'display': 'inline-table' }">
		          </dw-calendar>
       		 </span>
        </span>
        <button matTooltip="Clear response" mat-icon-button (click)="element.response=undefined" style="width: 0px; margin-left: -12px;">
			       <mat-icon aria-label="Clear selection" style="font-size: 10pt; cursor: pointer;">clear</mat-icon>
		</button>
        </td>
    </ng-container>

    <!-- Joins Column -->
    <ng-container matColumnDef="joins">
        <th mat-header-cell *matHeaderCellDef class="table-header-style-local" style="min-width: 100px; width: 100px;
         padding-left: 13px;">
            Joins
        </th>
        <td mat-cell style="width: 125px; padding-left: 13px;" *matCellDef="let element">
             <dw-dropdown
		                id="idJoin"
		                [selectedItem]="element.joins"
		                (itemSelected)="element.joins = $event"
		                [controlWidth]="'120px'"
                        [fontSize]="'9pt'"
                        [ngClass]="'dropdown-override'"
                        [disabled]="!element.chk || !element.response"
                        [useStatusOptions]="'andor'">
		            </dw-dropdown>
        </td>
    </ng-container>
         
            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr mat-row
                *matRowDef="let row; columns: displayedColumns; let tableRowIdx = index;"
                [ngClass]="{'row-selected': tableRowIdx == Idx}"
                (click)="onRowClicked(row)">
            </tr>
        </table>
</div>



</div>

 <div class="error-line-custom" [hidden]='!strErr.length'
                                     style="text-align:left">{{ strErr }}
</div>

<div class="advanced-filter-button-holder">
  	<button mat-button class="command-button"
            style="position: fixed;left: 7px;"
            (click)="doReset()" matTooltip="Reset the filters" [style]="{'width': '100px'}">
		Reset
		
	</button>
       <button mat-button class="command-button" (click)="doSubmit()"
               matTooltip="Submit the filters" [style]="{'width': '110px'}">
		Submit
	<mat-icon>check_circle_outline</mat-icon>
	</button>
	<button mat-button class="command-button" (click)="doCancel()"
            matTooltip="Cancel this dialog" [style]="{'width': '110px'}">
		Cancel
		<mat-icon>highlight_off</mat-icon>
	</button>
 </div>
